/**
 * New Services MobileDev
 */
const urlTeacher = import.meta.env.APP_URL_SRVROOTV2; //urlBase + "teacher/"
const urlGrupo = urlTeacher + "grupo/"
const urlEscolaridad = urlTeacher + "escolaridad/";
const urlChat = urlTeacher + "chat/";
const urlTutor = urlTeacher + "tutor/";
const urlAlumno = urlTeacher + "alumno/";
const urlEvento = urlTeacher + "evento/";
const urlAlimento = urlTeacher + "alimento/";
const urlEscuela = urlTeacher + "escuela/";
const urlLogro = urlTeacher + "logro/";
const urlUsuario = urlTeacher + "usuario/";
const urlSesion = urlTeacher + "sesion/";
const urlCalificacion = urlTeacher + "calificacion/";
const urlAgenda = urlTeacher + "agenda/";

export const apiGrupoEntrada = urlGrupo + "Entrada";
export const apiGrupoSalida = urlGrupo + "Salida";
export const apiGrupoSalidaEscuela = urlGrupo + "SalidaEscuela";
export const apiGrupoRechazarEntrada = urlGrupo + "RechazarEntrada";
export const apiGrupoLoginV4 = urlGrupo + "LoginV4";
export const apiGrupoCerrarSesion = urlGrupo + "CerrarSesion";
export const apiGrupoObtenerHorario = urlGrupo + "ObtenerHorario";
export const apiGrupoVerificarSesion = urlGrupo + "VerificarSesion";
export const apiGrupoEscanearQr = urlGrupo + "EscanearQr";
export const apiGrupoObtenerMaestrosInfo = urlGrupo + "ObtenerMaestrosInfo";
export const apiGrupoObtenerGruposInfo = urlGrupo + "ObtenerGruposInfo";

export const apiEscolaridadObtenerConfiguracion = urlEscolaridad + "ObtenerConfiguracion";

export const apiChatObtenerNoLeidosInicial = urlChat + "ObtenerNoLeidosInicialV2";
export const apiChatObtenerNoLeidosActualizacion = urlChat + "ObtenerNoLeidosActualizacionV2";
export const apiChatObtenerLista = urlChat + "ObtenerLista";
export const apiChatNuevoMensaje = urlChat + "NuevoMensaje";
export const apiChatObtenerArchivo = urlChat + "ObtenerArchivo?";//No se esta usando
export const apiChatMarcarMensajesLeidos = urlChat + "MarcarMensajesLeidosV2";

export const apiTutorObtenerLista = urlTutor + "ObtenerLista";

export const apiAlumnoObtenerLista = urlAlumno + "ObtenerLista";
export const apiAlumnoObtenerFoto = urlAlumno + "ObtenerFoto";
export const apiAlumnoObtenerEventos = urlAlumno + "ObtenerEventos";
export const apiAlumnoObtenerHorarioHoy = urlAlumno + "ObtenerHorarioHoy"
export const apiAlumnoObtenerInfo = urlAlumno + "ObtenerInfo";
export const apiAlumnoActualizarFotoPerfil = urlAlumno + "ActualizarFotoPerfil";
export const apiAlumnoObtenerExtemporaneosDisponiblesHoy = urlAlumno + "ObtenerExtemporaneosDisponiblesHoy";

export const apiEventoRegistrarAlimento = urlEvento + "RegistrarAlimento";
// export const apiEventoRegistrarFotoV2 = urlEvento + "RegistrarFotoV2";
export const apiEventoRegistrarFotoV3 = urlEvento + "RegistrarFotoV3";
// export const apiEventoRegistrarHigiene = urlEvento + "RegistrarHigiene";
export const apiEventoRegistrarHigieneV2 = urlEvento + "RegistrarHigieneV2";
export const apiEventoObtenerResumenEventos = urlEvento + "ObtenerResumenEventos";
export const apiEventoObtenerFoto = urlEvento + "ObtenerFoto";
export const apiEventoObtenerComidasEventos = urlEvento + "ObtenerComidasEventos";
// export const apiEventoRegistrarEventoSiestaV2 = urlEvento + "RegistrarEventoSiestaV2";
export const apiEventoRegistrarSiesta = urlEvento + "RegistrarSiesta";
// export const apiEventoRegistrarEventoGeneralV3 = urlEvento + "RegistrarEventoGeneralV3";
export const apiEventoRegistrarEventoGeneralV4 = urlEvento + "RegistrarEventoGeneralV4";
export const apiEventoObtenerComentariosEvento = urlEvento + "ObtenerComentariosEvento";
export const apiEventoObtenerEventosCalendario = urlEvento + "ObtenerEventosCalendario";
// export const apiEventoObtenerEventosChildV3 = urlEvento + "ObtenerEventosChildV3";

export const apiAlimentoObtenerTipos = urlAlimento + "ObtenerTipos";
export const apiAlimentoObtenerListaDelDia = urlAlimento + "ObtenerListaDelDia";

export const apiEscuelaObtenerClima = urlEscuela + "ObtenerClima";
export const apiEscuelaObtenerConfiguracion = urlEscuela + "ObtenerConfiguracion";

// export const apiLoadCovidScore = urlChild + "ObtenerPuntuacion";
export const apiLogroObtenerLogros = urlLogro + "ObtenerLogros";
// export const apiLogroEditarEstadoAsignacionV2 = urlLogro + "EditarEstadoAsignacionV2";
export const apiLogroEditarEstadoAsignacionV3 = urlLogro + "EditarEstadoAsignacionV3";
export const apiLogroObtenerCategorias = urlLogro + "ObtenerCategorias";
export const apiLogroObtenerAsignacionesChild = urlLogro + "ObtenerAsignacionesChild";
// export const apiLogroVisto = urlLogro + "Visto";

export const apiUsuarioObtenerGrupos = urlUsuario + "ObtenerGrupos";

export const apiSesionRecuperarContrasenia = urlSesion + "RecuperarContrasenia";

export const apiCalificacionObtenerPendientes = urlCalificacion + "ObtenerPendientes";
// export const apiCalificacionAsignarV2 = urlCalificacion + "AsignarV2";
export const apiCalificacionAsignarV3 = urlCalificacion + "AsignarV3";
// /** @deprecated */
// export const apiCalificacionAsignar = urlCalificacion + "Asignar";
export const apiCalificacionObtenerAsistencias = urlCalificacion + "ObtenerAsistencias";

export const apiAgendaObtenerTareas = urlAgenda + "ObtenerTareas";
export const apiAgendaNuevaTarea = urlAgenda + "NuevaTarea";
export const apiAgendaActualizarTarea = urlAgenda + "ActualizarTarea";
export const apiAgendaEliminarTarea = urlAgenda + "EliminarTarea";

//export const urlBase: string = "http://192.168.13.16/";//pruebas local
// const urlBase: string = "https://rst1-dev.kidi.mx/";//pruebas dominio
//export const urlBase: string = "https://rst1.kidi.mx/";//produccion

/** OLD */
// const ref_url_teacher = import.meta.env.APP_URL_SRVROOTV1; //urlBase + "MaestraJS/";

// const ref_agenda = ref_url_teacher + "Agenda/";
// export const apiOldAgendaObtenerTareasAgenda = ref_agenda + "ObtenerTareasAgenda";
// export const apiOldAgendaNuevaTareaAgenda = ref_agenda + "NuevaTareaAgenda";
// export const apiOldAgendaActualizarTareaAgenda = ref_agenda + "ActualizarTareaAgenda";
// export const apiOldAgendaEliminarTareaAgenda = ref_agenda + "EliminarTareaAgenda";

// const ref_event = ref_url_teacher + "Evento/"
// export const ref_event_RegistrarEventoGeneral = ref_event + "RegistrarEventoGeneralV2";
// export const ref_event_ObtenerEventosChildV2 = ref_event + "ObtenerEventosChildV2";
// export const ref_event_RegistrarEventoSiesta = ref_event + "RegistrarEventoSiesta";
// export const apiOldEventoObtenerComentariosEvento = ref_event + "ObtenerComentariosEvento";
// export const apiOldEventoObtenerEventosCalendario = ref_event + "ObtenerEventosCalendario";

// const ref_logro = ref_url_teacher + "Logro/";
// export const apiOldLogroObtenerLogros = ref_logro + "ObtenerLogros";
// export const apiOldLogroObtenerCategorias = ref_logro + "ObtenerCategorias";
// export const apiOldLogroObtenerLogrosAsignacionesChild = ref_logro + "ObtenerLogrosAsignacionesChild";
// export const ref_logro_LogroVisto = ref_logro + "LogroVisto";// Ya no aplica